import { Image } from "@mantine/core";
import { supportedCoins } from '../config/coins.config';
import { iconMap } from '../config/iconMap';

// Generate symbols from the centralized config
export const SYMBOLS = supportedCoins
	.filter(coin => coin.enabled)
	.filter(coin => iconMap[coin.symbol]) // Only include coins with defined icons
	.map(coin => ({
		name: coin.name,
		symbol: coin.symbol,
		code: coin.code,
		altcode: `${coin.baseCurrency}-${coin.quoteCurrency}`,
		icon: <Image src={iconMap[coin.symbol]} width={32} />,
		precision: coin.precision || coin.quantityDecimals,
		step: coin.step || Math.pow(10, -coin.quantityDecimals),
		min: coin.min || Math.pow(10, -coin.quantityDecimals),
		borrowRate: coin.borrowRate || 0
	}));

// For backward compatibility
export default SYMBOLS;